import { render, staticRenderFns } from "./ThanksStepSection.vue?vue&type=template&id=4cb31c9a&scoped=true"
import script from "./ThanksStepSection.vue?vue&type=script&lang=js"
export * from "./ThanksStepSection.vue?vue&type=script&lang=js"
import style0 from "./ThanksStepSection.vue?vue&type=style&index=0&id=4cb31c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb31c9a",
  null
  
)

export default component.exports